module.exports = __webpack_public_path__ + "media/images/countrysquared/cv-eab63be9cc6b4a2c23ff5ea5c4e54dd6.svg";